import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { dbSelectorSchema } from '../../lib/db-selector';
import { SqlService } from '../../service';

export type MultiAzConfig = typeof MultiAzConfig._.Config;

export const MultiAzConfig = IntegrationConfig.make({
  service: SqlService,
  name: Integration_Handler_Names_Enum.MultiAz,
  configSchema: z.object({
    dbSelectors: z.array(dbSelectorSchema).min(1),
  }),
});
